export default "__VITE_ASSET__DL4tGPQt__"